export default class SessionStorage {
  static get = (key) => {
    const data = window.sessionStorage.getItem(key);

    return data ? JSON.parse(data) : null;
  };

  static set = (key, value) => {
    window.sessionStorage.setItem(key, JSON.stringify(value));
  };

  static remove = (key) => window.sessionStorage.removeItem(key);
}
